// Stable portal target for T&C modals. Appends ONE invisible div to <body>
// the first time it's called, then reuses it forever. Body's direct child set
// stays constant across modal open/close — important on Ionic, where IonContent
// re-measures when body's children change and can collapse the page to ~0vh.
//
// Must only be called inside a useEffect (post-mount). Calling during render
// is a side-effect on document.body and triggers strict-mode double-mount
// warnings + occasional layout glitches in dev.
let modalRoot = null;
export function ensureModalRoot() {
    if (modalRoot && modalRoot.isConnected) return modalRoot;
    const existing = document.getElementById('swyftmedics-terms-modal-root');
    if (existing) {
        modalRoot = existing;
        return existing;
    }
    const el = document.createElement('div');
    el.id = 'swyftmedics-terms-modal-root';
    // Zero-area host. The modal inside uses position:fixed + inset:0 to fill
    // the viewport; the wrapper itself claims no layout space.
    el.style.position = 'fixed';
    el.style.zIndex = '2147483600';
    el.style.top = '0';
    el.style.left = '0';
    el.style.width = '0';
    el.style.height = '0';
    el.style.pointerEvents = 'none';
    document.body.appendChild(el);
    modalRoot = el;
    return el;
}

//# sourceMappingURL=modal-root.js.map